import React from 'react';
import { Glyphicon, Button, Modal, FormControl, FormGroup, ControlLabel, HelpBlock, ButtonToolbar } from 'react-bootstrap';

class NewPlayer extends React.Component {

    constructor(props) {
        super(props);

        this.onPlayerSelected = this.onPlayerSelected.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onSave = this.onSave.bind(this);

        this.state = {
            selectedPlayer: null,
            name: '',
            isValidName: true,
            isValidBase: true
        }
    }

    onPlayerSelected(e) {
        this.setState({ selectedPlayer: e.target.value, isValidBase: true });
    }

    onNameChange(e) {
        let isValid = true;

        if (!/^[a-zA-Z0-9-]*$/.test(e.target.value) || e.target.value === '')
            isValid = false;

        if (this.props.players.map((player) => player.toLowerCase()).indexOf(e.target.value.toLowerCase()) != -1)
            isValid = false;

        this.setState({ isValidName: isValid, name: e.target.value });
    }

    onSave() {
        let isValidBase = true;
        let isValidName = true;

        if (this.state.selectedPlayer == null)
            isValidBase = false;

        if (this.state.name === '')
            isValidName = false;

        if (!isValidName || !isValidBase) {
            this.setState({ isValidName: isValidName, isValidBase: isValidBase});
            return;
        }

        this.props.save(this.state.name, this.state.selectedPlayer);
    }

    render() {
        const options = [<option value="" key="default" disabled selected>Select a player</option>]
                        .concat(this.props.players.map((player) => <option key={player} value={player}>{player}</option>));

        const invalidNameMessage = 'A player with this name already exists or this name contains invalid characters, valid characters include: letters, numbers and hyphens';
        const invalidBaseMessage = 'A base player is required';

        return (
            <Modal show={true} onHide={this.props.close} container={this.props.container}>
                <Modal.Header closeButton>
                    <Modal.Title>New Player</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <FormGroup controlId="formInlineName" validationState={!this.state.isValidName ? 'error' : null}>
                    <ControlLabel>Name</ControlLabel>
                    <FormControl type="text" value={this.state.name} onChange={this.onNameChange}/>
                    <HelpBlock>{!this.state.isValidName && invalidNameMessage}</HelpBlock>
                </FormGroup>
                <FormGroup controlId="formInlineBase" validationState={!this.state.isValidBase ? 'error' : null}>
                    <ControlLabel>Base on</ControlLabel>
                    <FormControl componentClass="select" value={this.state.selectedPlayer} onChange={this.onPlayerSelected}>
                        {options}
                    </FormControl>
                    <HelpBlock>{!this.state.isValidBase && invalidBaseMessage}</HelpBlock>
                </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.close}>Cancel</Button>
                    <Button bsStyle='primary' onClick={this.onSave}>Save</Button>
                </Modal.Footer>
            </Modal>
        );
    }

}

export default NewPlayer;
